import { Link } from 'wouter'

import ImagePlaceholder from './ImagePlaceholder'
import './ImageLinkCard.css'

type ImageLinkCardProps = {
  label: string
  alt: string
  variant: 'flat-roof' | 'panels' | 'metal' | 'project'
  href: string
  large?: boolean
  compact?: boolean
  wide?: boolean
  darkLabel?: boolean
  imageSrc?: string
}

export default function ImageLinkCard({ label, alt, variant, href, large = false, compact = false, wide = false, darkLabel = false, imageSrc }: ImageLinkCardProps) {
  const imageAspect = compact ? 'aspect-[1.55] min-[900px]:aspect-[2.42]' : wide ? 'aspect-[2.2]' : large ? 'aspect-[1.72]' : 'aspect-[1.55]'

  return (
    <Link href={href} className="image-link-card group block overflow-hidden rounded-md">
      {imageSrc ? (
        <img src={imageSrc} alt={alt} className={`image-link-card__image w-full object-cover ${imageAspect}`} />
      ) : (
        <ImagePlaceholder alt={alt} variant={variant} showLabel={!compact} className={`${imageAspect} w-full`} />
      )}
      <span className={`image-link-card__label flex items-center justify-between px-3 py-2 text-sm font-semibold ${compact || wide ? 'min-[900px]:h-[33px] min-[900px]:px-[9px] min-[900px]:py-0' : ''} ${darkLabel ? 'image-link-card__label--dark' : 'image-link-card__label--light'}`}>
        {label}
        <span aria-hidden="true" className="image-link-card__arrow text-2xl font-light leading-none">›</span>
      </span>
    </Link>
  )
}
